import axios from "axios";
import { Notification, MessageBox, Message } from "element-ui";

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// 创建axios实例
const request = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: "https://api.hnzyxsbh.com/dagent",
  // 超时
  // timeout: 20000
});
// 请求拦截器
request.interceptors.request.use(
  (config) => {
    if (sessionStorage.getItem("token")) {
      // config.headers['Authorization'] = sessionStorage.getItem('token') // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["token"] = sessionStorage.getItem("token");
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let params = propName + "[" + key + "]";
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (config.method == "post") {
      if (config.data) {
        let data = "";
        for (let key in config.data) {
          if (data == "") {
            data += key + "=" + config.data[key];
          } else {
            data += "&" + (key + "=" + config.data[key]);
          }
        }
        config.data = data;
        data = "";
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (res) => {
    console.log(res);
    const code = res.data.code;
    if (res.config.url.indexOf("index.php/captcha") != -1) {
      return res.data;
    }
    if (code == 1) {
      return res.data;
    }
    if (code === 401) {
      MessageBox.confirm(
        "登录状态已过期，您可以继续留在该页面，或者重新登录",
        "系统提示",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        sessionStorage.clear();
        location.href = "/login";
      });
    } else if (code === 500) {
      Message({
        message: "服务器错误",
        type: "error",
      });
      return Promise.reject(new Error(msg));
    } else if (code != 1) {
      if (res.config.url == "/index.php/captcha") {
        return res.data;
      }
      Notification.error({
        title: res.data.msg,
      });
      return Promise.reject("error");
    } else {
      console.log(11111);
      return res.data;
    }
  },
  (error) => {
    if (error.response.status == 401) {
      MessageBox.confirm(
        "登录状态已过期，您可以继续留在该页面，或者重新登录",
        "系统提示",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        sessionStorage.clear();
        location.href = "/login";
      });
    }
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    // else if (message.includes("timeout")) {
    //   message = "系统接口请求超时";
    // }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default request;
